import { Box, Paper, styled, Typography } from '@mui/material';

export const LoginPageWrapperStyled = styled(Box)({
  minHeight: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  '& #chatbot-wrapper': {
    margin: '16px 0px 24px 0px !important',
  },
});

export const PaperStyled = styled(Paper)(({ theme }) => ({
  boxShadow: theme.customShadow,
  padding: theme.spacing(4),
  zIndex: 1,
  alignItems: 'center',
  '& .MuiFormControl-root': {
    marginTop: '0 !important',
  },
  '& .MuiPaper-root': {
    [theme.breakpoints.between('sm', 'lg')]: {
      width: '50rem !important',
      minWidth: '50rem !important',
    },
  },
  // phone
  [theme.breakpoints.only('xs')]: {
    minHeight: '500px',
    height: '70%',
  },
  // desktop && tablet
  [theme.breakpoints.up('sm')]: {
    margin: 'auto',
    maxHeight: '75rem',
    width: '50rem',
  },
}));

export const LogoWrapperStyled = styled(Box)({
  display: 'flex',
  margin: '0 auto',
  height: '7.2rem',
  width: 'calc(100% - 1.2rem)',
  alignItems: 'center',
  justifyContent: 'center',
});

export const BackgroundImageContainerStyled = styled('img')(({ theme }) => ({
  objectPosition: 'center',
  objectFit: 'cover',
  position: 'fixed',
  right: 0,
  top: 0,
  width: '100%',
  // phone
  [theme.breakpoints.only('xs')]: {
    height: '40%',
  },
  // desktop && tablet
  [theme.breakpoints.up('sm')]: {
    height: '100%',
  },
}));

export const DownloadInstructionsTypographyStyled = styled(Typography)({
  whiteSpace: 'pre-line',

  '& .MuiSvgIcon-root': {
    verticalAlign: 'bottom',
    color: '#0040DC',
    fontSize: '1.6rem',
  },
});
